// GA4 Analytics utility
declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

export function trackEvent(action: string, category: string, label?: string, value?: number) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
}

export function trackPageView(path: string, title?: string) {
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-2XG1C8Z1Y8', {
      page_path: path,
      page_title: title,
    });
  }
}

export function trackClick(label: string, category = 'engagement') {
  trackEvent('click', category, label);
}

export function trackNavClick(label: string) {
  trackClick(label, 'navigation');
}

export function trackCTAClick(label: string) {
  trackClick(label, 'cta');
}

export function trackDownload(label: string) {
  trackEvent('file_download', 'download', label);
}

export function trackLanguageSwitch(lang: string) {
  trackEvent('language_switch', 'engagement', lang);
}
